import { Timeline } from "$components";
import { Loader } from "$components/Layout/Loader";
import useEDBProfile from "$hooks/useEDBProfile";

export default function CollapsedTimeline({ row }: any) {
  const { edb, opList, tInfoData } = useEDBProfile(row._id);

  if (!edb) return <Loader />;

  return (
    <Timeline
      ops={opList}
      datePrevisionnelle={edb.scheduledInterventionDate || ""}
      edb={edb || undefined}
      hasProduct={!!(tInfoData || []).length || undefined}
    />
  );
}
